<ng-container *ngIf="gridConnectService?.isExcelExportEnabled() || false">
  <qpoint-toolbar-divider *ngIf="!gridConnectService.manuallyPlaceExcelExportButton()"></qpoint-toolbar-divider>
  <qpoint-toolbar-btn [badgeValue]="gridConnectService?.getSelectedRowCount()"
    [ngbTooltip]="excelExportTooltip()"
    [disabled]="disabled || gridConnectService?.getSelectedRowCount() < 1"
    [iconClass]="'file-download'" (btnClick)="exportExcel()">

  </qpoint-toolbar-btn>
</ng-container>